import React from 'react';
import { Shield, UserCheck, Truck, CheckCircle2, Heart } from 'lucide-react';
import { motion } from 'framer-motion';
export function WheelchairTransport() {
  return <div className="pt-44 pb-20" data-id="element-335">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-336">
        <div className="grid lg:grid-cols-2 gap-16 items-center mb-24" data-id="element-337">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} data-id="element-338">
            <h1 className="text-4xl md:text-5xl font-extrabold text-slate-900 mb-6 leading-tight" data-id="element-339">
              Specialized <span className="text-blue-600" data-id="element-340">Wheelchair</span>{' '}
              Transport Solutions
            </h1>
            <p className="text-lg text-slate-600 mb-8 leading-relaxed" data-id="element-341">
              At AMO, we specialize in safe, reliable, and compassionate
              door-to-door wheelchair transportation. Our service is designed
              for individuals who use wheelchairs or have mobility challenges,
              ensuring every journey is comfortable and secure.
            </p>
            <div className="space-y-4" data-id="element-342">
              {['Door-to-door assistance', 'State-of-the-art securement systems', 'Comfortable, climate-controlled vehicles', 'Trained and compassionate staff'].map(item => <div key={item} className="flex items-center text-slate-700 font-semibold" data-id="element-343">
                  <CheckCircle2 className="w-5 h-5 text-blue-600 mr-3" data-id="element-344" />
                  {item}
                </div>)}
            </div>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} className="relative" data-id="element-345">
            <img src="https://cdn.magicpatterns.com/uploads/9BkF54dhW9rhG3G5objMj2/Sample.jpg" alt="AMO Wheelchair Accessible Van" className="rounded-3xl shadow-2xl border-8 border-white bg-white w-full h-auto object-contain p-6" data-id="element-346" />
          </motion.div>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-347">
          <div className="bg-white p-8 rounded-2xl shadow-xl border border-slate-100" data-id="element-348">
            <div className="w-14 h-14 bg-blue-100 rounded-xl flex items-center justify-center mb-6" data-id="element-349">
              <Truck className="w-8 h-8 text-blue-600" data-id="element-350" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-351">Our Fleet</h3>
            <p className="text-slate-600 leading-relaxed" data-id="element-352">
              Our fleet consists of wheelchair-accessible vehicles equipped with
              state-of-the-art ramps, securement systems, and comfortable
              seating. Every vehicle is meticulously maintained.
            </p>
          </div>
          <div className="bg-white p-8 rounded-2xl shadow-xl border border-slate-100" data-id="element-353">
            <div className="w-14 h-14 bg-blue-100 rounded-xl flex items-center justify-center mb-6" data-id="element-354">
              <UserCheck className="w-8 h-8 text-blue-600" data-id="element-355" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-356">
              Trained Drivers
            </h3>
            <p className="text-slate-600 leading-relaxed" data-id="element-357">
              Every driver is carefully screened, background-checked, and
              dedicated to providing respectful, courteous service. They are
              trained in patient handling and safety protocols.
            </p>
          </div>
          <div className="bg-white p-8 rounded-2xl shadow-xl border border-slate-100" data-id="element-358">
            <div className="w-14 h-14 bg-blue-100 rounded-xl flex items-center justify-center mb-6" data-id="element-359">
              <Shield className="w-8 h-8 text-blue-600" data-id="element-360" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-361">
              Safety First
            </h3>
            <p className="text-slate-600 leading-relaxed" data-id="element-362">
              Safety is our top priority. We use industry-standard securement
              systems to ensure stability and peace of mind during every mile of
              the journey.
            </p>
          </div>
        </div>
      </div>
    </div>;
}